import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useMemo } from 'react'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'

const slackNotification = async payload => {
  const slackToken = localStorage.getItem('slack_access_token')
  if (!slackToken) {
    console.error('No authentication token available')
    return
  }

  try {
    const response = await axios.post(
      `${baseUrl}/aws/slack/notify`,
      payload, // Now directly sending JSON payload
      {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: slackToken,
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error sending notification message:', error)
    throw error // Re-throw the error for useMutation's onError to catch
  }
}

export const useSlackNotification = () => {
  const { showSnackbar } = useSnackbarContext()
  const queryClient = useQueryClient()
  const currentUser = useMemo(() => {
    const raw = localStorage.getItem('currentUser')
    return raw ? JSON.parse(raw) : null
  }, [])
  const currentUserId = currentUser?.user_uuid ?? null
  const mutation = useMutation({
    // Directly pass the object to the mutation function
    mutationFn: slackNotification,
    onSuccess: data => {
      console.log('Message Sent Successfully: ', data)
      queryClient.invalidateQueries({ queryKey: ['notifications', 'count', currentUserId] })
      showSnackbar('Notification sent successfully', 'success')
    },
    onError: error => {
      console.error('[useSlackNotification] Error sending message:', error)
      showSnackbar((error as any).response.data.message || error.message, 'error')
    },
  })

  return mutation
}
